export const ONBOARDING_STATUSES = [
  'new',
  'risk_file_created',
  'details_updated',
  'officers_updated',
  'invitation_code_accepted',
]

export const MANUAL_REVIEW_STATUSES = ['manual_review_required']

export const DECLINED_STATUSES = ['manual_review_failed']

export const AML_STATUSES = [
  'manual_review_omitted',
  'manual_review_passed',
  'payment_platform_id_creation_pending',
]

export const LIVE_STATUSES = ['payment_platform_id_created']

const SUSPENDED_STATUSES = ['suspended']

export const FAILED_STATUSES = ['payment_platform_id_failed']

export const isSDCMerchant = merchant =>
  !!merchant?.merchantRiskProfiles?.find(p =>
    ['SDC-unfunded', 'SDC-NL'].includes(p.lenderCode)
  )

export const isIB4UMerchant = merchant =>
  !!merchant?.groups?.some(g => g.id === 'ib4u_uk_group')

// Refunds for these merchants are paid out of a pre-funded HSBCnet account,
// so the merchant doesn't send us a bank transfer first.
export const getDedicatedRefundAccount = merchant => {
  if (isSDCMerchant(merchant)) {
    return { code: 'REF-SDC', name: 'SmileDirectClub' }
  }
  if (isIB4UMerchant(merchant)) {
    return { code: 'REF-IB4U', name: 'Invisiblebraces4u' }
  }
  return null
}

const getMerchantState = status => {
  if (ONBOARDING_STATUSES.includes(status)) {
    return 'onboarding'
  }

  if (MANUAL_REVIEW_STATUSES.includes(status)) {
    return 'manual_review'
  }

  if (DECLINED_STATUSES.includes(status)) {
    return 'declined'
  }

  if (AML_STATUSES.includes(status)) {
    return 'aml'
  }

  if (LIVE_STATUSES.includes(status)) {
    return 'live'
  }

  if (SUSPENDED_STATUSES.includes(status)) {
    return 'suspended'
  }
}

const normalizeMerchantUsers = (users = []) =>
  users.map(u => ({
    ...u,
    email: u.user.email,
    status: u.user.status,
    lastLogin: u.user.lastLogin,
  }))

const normalizeMerchantActivity = merchant => {
  const { stateMachineTransitions = [], createdAt } = merchant
  stateMachineTransitions.unshift({
    to: 'new',
    at: createdAt,
    uuid: '23423423',
  })
  return stateMachineTransitions
}

const normalize = merchant => {
  const state = getMerchantState(merchant.status)
  const merchantUsers = normalizeMerchantUsers(merchant.merchantUsers)
  const activity = normalizeMerchantActivity(merchant)

  const financeFundGateway = merchant.merchantFundConfigs?.find(
    f => f.productType === 'finance'
  )

  const isUK = merchant?.countryCode === 'gb'
  const isNL = merchant?.countryCode === 'nl'
  const isIT = merchant?.countryCode === 'it'
  const isFR = merchant?.countryCode === 'fr'

  const isEU = isNL || isIT || isFR

  return {
    ...merchant,
    merchantUsers,
    activity,
    state,
    isSDCMerchant: isSDCMerchant(merchant),
    dedicatedRefundAccount: getDedicatedRefundAccount(merchant),
    financeFundGateway,
    isUK,
    isNL,
    isIT,
    isFR,
    isEU,
  }
}

export default normalize
